import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

// Slika iz Markdown teksta: u tekstu je manja sličica, a klik je otvara u većem prikazu preko celog ekrana.
function ZoomImage({ src, alt }: { src?: string; alt?: string }) {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!open) return;
        const onKey = (e: KeyboardEvent) => {
            if (e.key === 'Escape') setOpen(false);
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [open]);

    return (
        <>
            <img
                src={src}
                alt={alt}
                loading="lazy"
                title="Kliknite za veći prikaz"
                onClick={(e) => {
                    e.stopPropagation();
                    setOpen(true);
                }}
                className="max-w-full w-auto h-auto object-contain rounded-[8px] cursor-zoom-in md:max-h-[207px] md:max-w-[300px]"
            />
            {open &&
                createPortal(
                    <div
                        className="fixed inset-0 z-[60] bg-black/80 flex items-center justify-center p-4 cursor-zoom-out"
                        onClick={(e) => {
                            e.stopPropagation();
                            setOpen(false);
                        }}
                    >
                        <img src={src} alt={alt} className="max-w-[95vw] max-h-[90dvh] w-auto h-auto object-contain rounded-[8px]" />
                    </div>,
                    document.body,
                )}
        </>
    );
}

export default ZoomImage;
